import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}

function LegPan002({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M125.7.05l.05-.05Q61.85 12.5 0 0q0 .05.05.1v12.45H125.7V.05z"
                    id="LegPan002__Symbol_2_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#LegPan002__Symbol_2_0_Layer0_0_FILL"
                transform="translate(129.65 310.25)"
                id="LegPan002__col1n"
            />
        </g></g>
    )
}

export default LegPan002
